import React from "react"
import { Box, Paper, Typography } from "@mui/material"
import { useContext } from "react"
import UserContext from "../../context/UserContext"

const Lizenzen = () => {
  const {
    userData: { school },
  } = useContext(UserContext)

  return (
    <Box
      sx={{
        position: "fixed",
        top: "1vw",
        left: "12vw",
        borderRadius: "38px",
        backgroundColor: "white",
        height: "calc(100vh - 2vw)",
        width: "87vw",
        p: "1vw",
        overflow: "auto",
        msOverflowStyle: "-ms-autohiding-scrollbar" /* IE and Edge */, // ????
        scrollbarWidth: "none" /* Firefox */,
      }}>
      <Typography variant="h5" align="left" sx={{ color: "bmsecondary.main", ml: "1vw", pt: "1vw" }} gutterBottom>
        Lizenzen
      </Typography>

      <Paper sx={{ ml: 1, mt: 4, p: 2, width: "fit-content", backgroundColor: "#eee" }}>
        <Typography variant="body1" gutterBottom>
          <b>{school.name}</b> {school.isTestEnv && <i>Testumgebung</i>}
        </Typography>

        <Typography variant="body1">Gültig bis: {new Date(school.validUntil).toLocaleDateString()}</Typography>

        <Typography variant="body1">Nutzername (Schulzugang): {school.username}</Typography>

        <Typography variant="body1">
          Code zum Registrieren (Schülerzugang): <b>{school.code}</b>
        </Typography>
      </Paper>
    </Box>
  )
}

export default Lizenzen
